<template>
	<b-row  :class="(is_deleted ? 'archived-section' : ((is_full_disbursement || is_special_condition) ? '':'wait-full-disb-section'))">
		<b-col cols="12">
			<CollectionSummary />
			<!-- <el-collapse v-model="activeNames">
				<el-collapse-item title="Disbursement Details" name="1" disabled>
					<template slot="title">
						<div class="p-2 d-flex justify-content-between align-items-center w-100">
							<h4 class="mb-0">Disbursement Details</h4>
							<el-button type="primary" plain size="small">
								+ Add Disbursement
							</el-button>
						</div>
					</template>
				</el-collapse-item>
			</el-collapse> -->
			<CollectionDetail />
		</b-col>
	</b-row>
</template>

<script>
import { Button, Collapse, CollapseItem } from 'element-ui'
import CollectionSummary from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Collection/CollectionSummary'
import CollectionDetail from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Collection/CollectionDetail'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	components: {
		CollectionSummary,
		CollectionDetail,
		[Button.name]: Button,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
	},
	data() {
		return {
			activeNames: ['1']
		};
	},
	computed:{
		...mapState(useLoanCaseStore, ['activeCase']),
		is_full_disbursement(){
			let disb_status = _gHlp.getValue(this.activeCase,'disb_status_detail.name',null);
			return (!_gHlp.isEmpty(disb_status) && (disb_status == 'Full Disbursement'));
		},
		is_special_condition(){
			let status_id = _gHlp.getValue(this.activeCase,'status_id',null);
			return status_id == 49; //Credit Pull Back
		},
		is_deleted(){
			return !_gHlp.isEmpty(this.activeCase.deleted_at);
		}
  },
	methods: {
		handleChange(val) {
			// console.log(val);
		}
	}
}
</script>